<template>
  <div
    class="coin3d"
  >
    <div
      ref="coinface"
      class="coin3d__coinface"
      :class="{global: globalPosition}"
    >
      <slot />
    </div>
  </div>
</template>
<script>
import _ from 'lodash'; //eslint-disable-line

export default {
  props: {
    globalPosition: {
      type: Boolean,
      default: false,
    },
    mouseEvents: {
      type: Boolean,
      default: true,
    },
    gyroEvents: {
      type: Boolean,
      default: false,
    },
    appearFrom: {
      type: Object,
      default: () => ({ x: 0, y: 0 }),
    },
  },
  data() {
    return {
      x: 0,
      y: 0,
    };
  },
  mounted() {
    this.throttleHandleMouseMove = _.throttle(this.handleMouseMove, 1000 / 60);
    window.addEventListener('mousemove', this.throttleHandleMouseMove);
    // window.addEventListener('deviceorientation', this.gyroHandler, true);
    // window.addEventListener('devicemotion', this.handleDeviceMotion, true);
    this.raf = window.requestAnimationFrame(this.updateMousePos);
  },
  beforeDestroy() {
    window.removeEventListener('mousemove', this.throttleHandleMouseMove);
    // window.removeEventListener('deviceorientation', this.gyroHandler, true);
    // window.removeEventListener('devicemotion', this.handleDeviceMotion, true);
    window.cancelAnimationFrame(this.raf);
  },
  methods: {
    mapRange(value, inMin, inMax, outMin, outMax) {
      return ((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin; // eslint-disable-line no-mixed-operators
    },
    clamp(value, min, max) {
      return Math.min(max, Math.max(min, value));
    },
    handleMouseMove(event) {
      const coinface = this.$refs.coinface;
      if (coinface) {
        const { clientX, clientY } = event;
        this.x = clientX;
        this.y = clientY;
      }
    },
    handleDeviceMotion(event) {
      const coinface = this.$refs.coinface;
      if (coinface) {
        const { accelerationIncludingGravity } = event;
        if (accelerationIncludingGravity) {
          const { x, y } = accelerationIncludingGravity;
          this.x = this.mapRange(x, -10, 10, 0, window.innerWidth);
          this.y = this.mapRange(y, -10, 10, 0, window.innerHeight);
        }
      }
    },
    updateMousePos() {
      const coinface = this.$refs.coinface;
      if (coinface) {
        const {
          left, top, width, height,
        } = coinface.getBoundingClientRect();
        const x = this.clamp(this.mapRange(this.x - left, 0, width, -1, 1), -1, 1);
        const y = this.clamp(this.mapRange(this.y - top, 0, height, -1, 1), -1, 1);
        coinface.style.setProperty('--x', x);
        coinface.style.setProperty('--y', y);
        this.raf = window.requestAnimationFrame(this.updateMousePos);
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.coin3d {
perspective: 600px;

  &__coinface {
    z-index: 10;
    +desktop() {
      --angle-x: calc(var(--y, 0) * -6deg);
      --angle-y: calc(var(--x, 0) * 6deg);
      --translateZ: 20px;

      &.global {
        --angle-x: calc(var(--y, 0) * -3deg);
      --angle-y: calc(var(--x, 0) * 3deg);
        --translateZ: 0;
      }

      transition: transform 0.5s ease-out, filter 0.5s ease-out;
      aspect-ratio: 453 / 444;
      overflow: hidden;
      filter: none
      perspective: 600px;
      will-change: transform
      &:after {
        --angle: calc(calc(atan2(var(--y), var(--x)) + 90deg) - 180deg);
        content: '';
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        opacity: 0;
        background: linear-gradient(var(--angle), rgba(255, 255, 255, 0.3) 30%, rgba(0, 0, 0, 0.3) 100%);
        border-radius: 50%;
        transition: opacity 0.5s ease-out;
        filter: blur(2px);
        mix-blend-mode: overlay;
        z-index: 100;
      }

      @media (hover: hover) {
        &:hover, &.global {
          filter: drop-shadow(calc(var(--x) * -30px) calc(var(--y) * -30px) 20px rgba(0, 0, 0, 0.2));
          transition-duration: 0.2s;
          transform: translateZ(var(--translateZ, 0)) rotateX(var(--angle-x)) rotateY(var(--angle-y));
          &:after {
            opacity: 0.5;
          }
        }
      }
    }
  }
}
</style>
